import { render, staticRenderFns } from "./BestCourses.vue?vue&type=template&id=ab81e028&"
import script from "./BestCourses.vue?vue&type=script&lang=js&"
export * from "./BestCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports